import React from "react";

import { CardHeader, CardLayout } from "../cards";
import { Box } from "../elements";
import { RoundAvatar } from "../RoundAvatar";
import { DuelText } from "../DuelText";

export const YardInfo = ({ yard, handleEdit, handleDelete }) => {
  return (
    <CardLayout>
      <CardHeader
        title={"Yard Information"}
        dotsMenu={{
          dots: "more_horiz",
          dropdown: [
            { icon: "edit", text: "edit", onClick: handleEdit },
            {
              icon: "delete",
              text: "delete",
              onClick: handleDelete,
            },
          ],
        }}
      />
      <Box className="mc-user-group">
        <Box className="mc-user-profile">
          <RoundAvatar src="/images/warehouse.jpg" alt="avatar" size="lg d-inline-flex m-3" />
          <DuelText title={yard?.yardName} descrip={yard?.yardLocation} size={"lg"} textStyle={{ textTransform: "uppercase" }} />
        </Box>
      </Box>
    </CardLayout>
  );
};
